<template>
  <div class="cells" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    paddingTop: {
      type: String,
      default: '0pt'
    },
    paddingBottom: {
      type: String,
      default: '0pt'
    },
    paddingLeft: {
      type: String,
      default: '0pt'
    },
    paddingRight: {
      type: String,
      default: '0pt'
    }
  },
  computed: {
    style () {
      return {
        'padding-left': this.paddingLeft,
        'padding-right': this.paddingRight,
        'padding-top': this.paddingTop,
        'padding-bottom': this.paddingBottom
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'
.cells
  box-sizing border-box
  border-radius pt(10)
  background white
  center-with-padding()
</style>




// WEBPACK FOOTER //
// cells.vue?387db908